import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genStepsProgressDotStyle = function genStepsProgressDotStyle(token) {
  var _$concat, _$concat2, _$concat$concat, _ref;

  var componentCls = token.componentCls,
      descriptionMaxWidth = token.descriptionMaxWidth,
      lineHeight = token.lineHeight,
      dotCurrentSize = token.dotCurrentSize,
      dotSize = token.dotSize,
      motionDurationSlow = token.motionDurationSlow;
  return _ref = {}, _defineProperty(_ref, "&".concat(componentCls, "-dot, &").concat(componentCls, "-dot").concat(componentCls, "-small"), _defineProperty({}, "".concat(componentCls, "-item"), (_$concat = {
    '&-title': {
      lineHeight: lineHeight
    },
    '&-tail': {
      top: Math.floor((token.dotSize - token.lineWidth * 3) / 2),
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
      marginInline: "".concat(descriptionMaxWidth / 2, "px 0"),
      padding: 0,
      '&::after': {
        width: "calc(100% - ".concat(token.marginSM * 2, "px)"),
        height: token.lineWidth * 3,
        marginInlineStart: token.marginSM
      }
    },
    '&-icon': _defineProperty({
      width: dotSize,
      height: dotSize,
      marginInlineStart: (token.descriptionMaxWidth - dotSize) / 2,
      paddingInlineEnd: 0,
      lineHeight: "".concat(dotSize, "px"),
      background: 'transparent',
      border: 0
    }, "".concat(componentCls, "-icon-dot"), {
      position: 'relative',
      float: 'left',
      width: '100%',
      height: '100%',
      borderRadius: 100,
      transition: "all ".concat(motionDurationSlow),

      /* expand hover area */
      '&::after': {
        position: 'absolute',
        top: -token.marginSM,
        insetInlineStart: (dotSize - token.controlHeightLG * 1.5) / 2,
        width: token.controlHeightLG * 1.5,
        height: token.controlHeight,
        background: 'transparent',
        content: '""'
      }
    }),
    '&-content': {
      width: descriptionMaxWidth
    }
  }, _defineProperty(_$concat, "&-process ".concat(componentCls, "-item-icon"), {
    position: 'relative',
    top: (dotSize - dotCurrentSize) / 2,
    width: dotCurrentSize,
    height: dotCurrentSize,
    lineHeight: "".concat(dotCurrentSize, "px"),
    background: 'none',
    marginInlineStart: (token.descriptionMaxWidth - dotCurrentSize) / 2
  }), _defineProperty(_$concat, "&-process ".concat(componentCls, "-icon"), _defineProperty({}, "&:first-child ".concat(componentCls, "-icon-dot"), {
    insetInlineStart: 0
  })), _$concat))), _defineProperty(_ref, "&".concat(componentCls, "-vertical").concat(componentCls, "-dot"), (_$concat$concat = {}, _defineProperty(_$concat$concat, "".concat(componentCls, "-item-icon"), {
    marginTop: (token.controlHeight - dotSize) / 2,
    marginInlineStart: 0,
    background: 'none'
  }), _defineProperty(_$concat$concat, "".concat(componentCls, "-item-process ").concat(componentCls, "-item-icon"), {
    marginTop: (token.controlHeight - dotCurrentSize) / 2,
    top: 0,
    insetInlineStart: (dotSize - dotCurrentSize) / 2,
    marginInlineStart: 0
  }), _defineProperty(_$concat$concat, "".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    top: (token.controlHeight - dotSize) / 2,
    insetInlineStart: 0,
    margin: 0,
    padding: "".concat(dotSize + token.paddingXS, "px 0 ").concat(token.paddingXS, "px"),
    '&::after': {
      marginInlineStart: (dotSize - token.lineWidth) / 2
    }
  }), _defineProperty(_$concat$concat, "&".concat(componentCls, "-small"), (_$concat2 = {}, _defineProperty(_$concat2, "".concat(componentCls, "-item-icon"), {
    marginTop: (token.controlHeightSM - dotSize) / 2
  }), _defineProperty(_$concat2, "".concat(componentCls, "-item-process ").concat(componentCls, "-item-icon"), {
    marginTop: (token.controlHeightSM - dotCurrentSize) / 2
  }), _defineProperty(_$concat2, "".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    top: (token.controlHeightSM - dotSize) / 2
  }), _$concat2)), _defineProperty(_$concat$concat, "".concat(componentCls, "-item:first-child ").concat(componentCls, "-icon-dot"), {
    insetInlineStart: 0
  }), _defineProperty(_$concat$concat, "".concat(componentCls, "-item-content"), {
    width: 'inherit'
  }), _$concat$concat)), _ref;
};

export default genStepsProgressDotStyle;